import { Backend } from '@/_axios';

export default {
  index(page) {
    return Backend.get('/activities/', { params: { page } });
  },

  list({
    projectId, params
  }) {
    return Backend.get(`/project/${projectId}/activities`,
      { params, cancelDuplicates: true });
  },

  listLabelSetActivities({
    projectId, labelSetId, sampleId = null, ...filters
  }) {
    return Backend.get(`/project/${projectId}/label_sets/activities`,
      { params: { label_set_id: labelSetId, sample_id: sampleId, ...filters }, cancelDuplicates: true });
  },
};
